export default __webpack_public_path__ + "assets/models/f5f4abab4286507b7b1ac8bf0851e702.glb";